<div class="content space-y-4">
    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <button class="text-gray-500 hover:text-primary-500 transition-colors mr-1" (click)="back()">
                <fa-icon [icon]="faArrowLeft"></fa-icon>
            </button>
            <fa-icon [icon]="faReceipt" class="text-primary-500 text-xl"></fa-icon>
            <span>รายละเอียดใบรับเข้า</span>
            <span class="label label-primary !text-xs">สาขา</span>
        </div>
    </div>

    <div class="card space-y-4">
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4">
            <div>
                <div class="text-xs text-gray-500">เลขที่</div>
                <div class="font-mono font-semibold text-primary-600">{{ orderNo || '-' }}</div>
            </div>
            <div>
                <div class="text-xs text-gray-500">สาขา</div>
                <div class="font-medium">{{ branchName || '-' }}</div>
            </div>
            @if (!loading) {
            <div>
                <div class="text-xs text-gray-500">สถานะ</div>
                @if (receiveDate) {
                <span class="label !text-xs bg-green-100 text-green-700">รับเข้าแล้ว</span>
                } @else if (packDate) {
                <span class="label !text-xs bg-yellow-100 text-yellow-700">แพ็คแล้ว · รอรับเข้า</span>
                } @else {
                <span class="label !text-xs bg-red-100 text-red-700">ยังไม่ได้แพ็ค</span>
                }
            </div>
            }
        </div>
        @if (!loading) {
        <div class="grid grid-cols-2 md:grid-cols-3 gap-4 pt-3 border-t">
            <div>
                <div class="text-xs text-gray-500">วันที่สั่ง</div>
                <div>{{ orderDate || '-' }}</div>
            </div>
            <div>
                <div class="text-xs text-gray-500">วันที่โยกคลัง</div>
                <div [ngClass]="{'text-red-500': !packDate}">{{ packDate || 'ยังไม่ได้แพ็ค' }}</div>
            </div>
            <div>
                <div class="text-xs text-gray-500">วันที่รับเข้า</div>
                <div [ngClass]="{'text-red-500': packDate && !receiveDate}">
                    @if (receiveDate) {
                    {{ receiveDate }}
                    } @else if (packDate) {
                    ยังไม่ได้รับเข้า
                    } @else {
                    -
                    }
                </div>
            </div>
        </div>
        }
    </div>

    @if (loading) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    } @else if (errorMessage) {
    <div class="card">
        <div class="text-sm text-red-500 py-4 text-center">{{ errorMessage }}</div>
    </div>
    } @else if (rows.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium text-gray-600">ไม่มีสินค้าในใบรับเข้า</div>
        </div>
    </div>
    } @else {
    <div class="card">
        <div class="flex items-center justify-between mb-3">
            <div class="text-sm font-semibold text-gray-700">รายการสินค้า</div>
            <div class="flex items-center gap-4 text-sm">
                <div class="text-gray-500">
                    จำนวนรายการ
                    <span class="font-semibold text-gray-700 ml-1">{{ rows.length | number }}</span>
                </div>
                <div class="text-gray-500">
                    รวมจำนวน
                    <span class="font-semibold text-primary-600 ml-1">{{ totalQty | number }}</span>
                </div>
            </div>
        </div>
        <div class="div-table">
            <table>
                <thead>
                    <tr class="thead-tr divide-x">
                        <th class="text-left">สินค้า</th>
                        <th class="text-center">จำนวนสินค้า</th>
                        <th class="text-center">สต๊อก Sabuysoft</th>
                        @for (channelsHeader of channelsHeaders; track $index) {
                        <th>{{ channelsHeader }}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of rows; track $index) {
                    <tr class="tbody-tr divide-x">
                        <td>
                            <div class="flex items-center">
                                <img [src]="'https://storage.maxxgadget.com/img/product/' + row.sku + '/1.jpg'"
                                    alt="" class="flex-none w-10 h-10 mr-3 rounded object-cover bg-gray-50"
                                    onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                <div class="w-full flex flex-col truncate">
                                    <span class="truncate">{{ row.product_name }}</span>
                                    <span class="text-xs text-blue-500 font-mono">{{ row.sku }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center font-semibold text-primary-600">{{ row.qty | number }}</td>
                        <td class="text-center font-semibold"
                            [class.bg-red-50]="row.stockMismatch"
                            [ngClass]="{
                                'text-gray-400': row.sabuysoft_stock === null,
                                'text-lime-600': row.sabuysoft_stock !== null && row.sabuysoft_stock > 0,
                                'text-red-500': row.sabuysoft_stock !== null && row.sabuysoft_stock <= 0
                            }">
                            {{ row.sabuysoft_stock !== null ? (row.sabuysoft_stock | number) : '-' }}
                        </td>
                        @for (channelsHeader of channelsHeaders; track $index) {
                        <td class="text-left border-r w-36"
                            [class.bg-red-50]="row.stockMismatch && channelsHeader === row.mismatchPlatform">
                            <div class="space-y-2 w-36">
                                @for (product of getStockByPlatform(channelsHeader, row.stocks); track $index) {
                                <div class="flex justify-center items-center w-full"
                                    [matTooltip]="getTooltipText(product)"
                                    matTooltipClass="!w-44 whitespace-pre-line text-left">
                                    <div class="flex items-center">
                                        <div class="text-gray-500 text-xs pr-2 truncate">
                                            <span>{{ product.channel_name }}:</span>
                                        </div>
                                    </div>
                                    <div class="font-semibold text-primary-500"
                                        [ngClass]="{'text-red-500': product.sellable === 0}">
                                        {{ product.sellable }}
                                    </div>
                                </div>
                                }
                            </div>
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }
</div>
